<template>
  <NumberActionItems
    :current-number="number"
    :can-edit="numberContext.canEditNumber(number)"
    :can-delete="!numberContext.activeNumber && numberContext.canDeleteNumber(number)"
    :pause-available="number.enabled && numberContext.isAdmin"
    :can-pause="!numberContext.activeNumber"
    :enable-available="!number.enabled && numberContext.isAdmin"
    @on-edit="numberContext.showForm(number)"
    @on-delete="numberContext.confirmDeleteModal(number)"
    @on-pause="numberContext.confirmNumberPause(number)"
    @on-enable="numberContext.setNumberStatus(number, true)"
    @activate="numberContext.showForm(number)"
  />
</template>

<script>
import { defineComponent } from 'vue';
import NumberActionItems from './NumberActionItems.vue';

export default defineComponent({
  components: {
    NumberActionItems,
  },
  inject: ['numberContext'],
  props: {
    number: {
      type: Object,
      required: true,
    },
  },
});
</script>
